import React from "react";
import { Box, Typography } from "@mui/material";

export default function WizardProgressHeader({
  title = "Let’s set things up for your event.",
  subtitle = "",
  steps = [],
  active = 0,
  showTitle = true,
}) {
  const total = Math.max(steps.length, 1);
  const clamped = Math.min(Math.max(active, 0), total - 1);
  const pct = Math.round(((clamped + 1) / total) * 100);

  return (
    <Box>
      {showTitle && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      )}

      {/* Slim progress bar (brand color) */}
      <Box
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        sx={{
          height: 6,
          borderRadius: 999,
          bgcolor: (t) =>
            t.palette.mode === "dark"
              ? t.palette.grey[800]
              : t.palette.grey[200],
          overflow: "hidden",
        }}>
        <Box
          sx={{
            width: `${pct}%`,
            height: "100%",
            bgcolor: (t) => t.palette.primary.main, // #FD7762
            transition: "width .25s ease",
          }}
        />
      </Box>

      <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 700 }}>
        {`Step ${clamped + 1} of ${total}: ${steps[clamped] || ""}`}
      </Typography>
    </Box>
  );
}
